import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const needsDepth = ["l-shape", "u-shape", "full-enclosure", "peaked", "multi-panel", "double-opening", "full-perimeter"];

export default function StepDimensions({ form, setForm }) {
  const showDepth = needsDepth.includes(form.layout);
  const handleChange = (e) => setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Enter Dimensions
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">Provide approximate measurements. We'll confirm during consultation.</p>

      {/* Unit Toggle */}
      <div className="flex items-center gap-2 mb-8">
        <span className="text-sm text-[#A3A3A3] mr-2">Units:</span>
        {["metres", "millimetres"].map((u) => (
          <button
            key={u}
            type="button"
            data-testid={`unit-${u}`}
            onClick={() => setForm((prev) => ({ ...prev, unit: u }))}
            className={`px-4 py-2 text-xs font-semibold uppercase tracking-wider transition-all ${
              form.unit === u
                ? "bg-[#FF5722] text-white"
                : "bg-[#1F1F1F] border border-[#2E2E2E] text-[#A3A3A3] hover:border-[#FF5722]/50"
            }`}
          >
            {u}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl">
        <div>
          <Label className="text-sm font-medium text-[#A3A3A3] mb-2 block">
            Height ({form.unit === "metres" ? "m" : "mm"})
          </Label>
          <Input
            name="height"
            data-testid="dim-height"
            value={form.height}
            onChange={handleChange}
            placeholder={form.unit === "metres" ? "e.g. 4.5" : "e.g. 4500"}
            className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
          />
        </div>
        <div>
          <Label className="text-sm font-medium text-[#A3A3A3] mb-2 block">
            Width ({form.unit === "metres" ? "m" : "mm"})
          </Label>
          <Input
            name="width"
            data-testid="dim-width"
            value={form.width}
            onChange={handleChange}
            placeholder={form.unit === "metres" ? "e.g. 10" : "e.g. 10000"}
            className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
          />
        </div>
        {showDepth && (
          <div>
            <Label className="text-sm font-medium text-[#A3A3A3] mb-2 block">
              Depth ({form.unit === "metres" ? "m" : "mm"})
            </Label>
            <Input
              name="depth"
              data-testid="dim-depth"
              value={form.depth}
              onChange={handleChange}
              placeholder={form.unit === "metres" ? "e.g. 6" : "e.g. 6000"}
              className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
            />
          </div>
        )}
        <div>
          <Label className="text-sm font-medium text-[#A3A3A3] mb-2 block">Quantity</Label>
          <Input
            name="quantity"
            type="number"
            min="1"
            data-testid="dim-quantity"
            value={form.quantity}
            onChange={handleChange}
            className="bg-[#1F1F1F] border-[#2E2E2E] text-white placeholder:text-[#666] focus:ring-1 focus:ring-[#FF5722] focus:border-[#FF5722] rounded-none h-12"
          />
        </div>
      </div>
    </div>
  );
}
